import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { Column, ContentContainer, Description, Main } from './SoleraLinkAccount.styled';
import solera from 'assets/solera/solera.svg';
import { Heading } from 'components/v2/Typography/Heading';
import { ReduxState } from 'kb-redux';
import { GoogleAuthError } from 'kb-shared/types';
import { KindbodyLogo } from 'layouts/MainLayout/Logo/KindBodyLogo';
import { SignUpButtons } from 'screens/Book/components/SignUpButtons/SignUpButtons';
import { showErrorToast } from 'utilities/notificationUtils';
import { pageUrl } from 'utilities/pageUrl';
import { useBreakpoints } from 'utilities/useBreakpoints';

export const SoleraLinkAccount = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDesktop } = useBreakpoints();
  const [soleraUid, setSoleraUid] = useState('');
  const isLoggedIn = Boolean(useSelector<ReduxState>(state => state.patient.isLoggedIn));
  const googleAuthError = useSelector<ReduxState, GoogleAuthError | null>(
    state => state.patient.googleAuthError
  );
  const googleUserId = useSelector<ReduxState>(state =>
    state.patient.patient.google ? state.patient.patient.google.id : null
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const uid = params.get('lookupKey');

    if (uid) setSoleraUid(uid);
  }, [location.search]);

  useEffect(() => {
    if (isLoggedIn) navigate(pageUrl.dashboard());

    if (!googleUserId) return;
    if (!googleAuthError) return;

    if (googleAuthError.type === 'UserAlreadyExistsAsEmail') {
      showErrorToast(
        'You already have an account using your email address and password. Please login'
      );
      return;
    }
    if (googleAuthError && googleAuthError.type !== 'UserHasNotSignedUp') return;
    goToCreateAccount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, googleAuthError]);

  const goToCreateAccount = () => {
    navigate(pageUrl.createAccount({ step: 'create_account', solerUid: soleraUid }));
  };

  return (
    <ContentContainer>
      <Column>
        <KindbodyLogo href="https://kindbody.com/" marginTop="20" />
        <Heading tag="span" styledAs={1 < 2 ? 'h1' : 'h2'}>
          Connect your Solera account with Kindbody
        </Heading>
        <Description>
          By clicking on either one of your preferences below, we will create your Kindbody account
          and link it to your Solera account. You will need to provide additional information to
          finalize the set-up.
        </Description>
        <Main>
          <SignUpButtons onSignUpWithEmail={goToCreateAccount} />
        </Main>
      </Column>
      {isDesktop && (
        <div>
          <img src={solera} height={456} width={400} alt="Kindbody and Solera Welcome" />
        </div>
      )}
    </ContentContainer>
  );
};
